import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-[#0f1b2d] py-16 md:py-24 px-4" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl text-gray-200 mb-4" data-id="element-88">
          Protege tu empleo, tu salud y tu tranquilidad por menos de lo que
          cuesta un almuerzo.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-lg text-gray-300 mb-8" data-id="element-89">
          Accede ahora al Kit de{' '}
          <span className="text-[#a8d8d8] font-semibold" data-id="element-90">
            "Calma en el Turno"
          </span>
          .
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-br from-[#1a2e4a] to-[#0f1b2d] p-8 md:p-12 rounded-3xl border border-[#3d7a8a]/30 mb-8" data-id="element-91">
          <div className="inline-block bg-amber-500/20 text-amber-400 px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-92">
            Precio Especial de Lanzamiento
          </div>

          <div className="mb-6" data-id="element-93">
            <span className="text-6xl md:text-7xl font-bold text-white" data-id="element-94">
              $19
            </span>
            <span className="text-xl text-gray-400 ml-2" data-id="element-95">(Pago único)</span>
          </div>

          <CTAButton className="mb-6" data-id="element-96">¡QUIERO MI KIT DE CALMA AHORA!</CTAButton>

          <p className="text-gray-400 text-sm flex items-center justify-center gap-2" data-id="element-97">
            <LockIcon className="w-4 h-4" data-id="element-98" />
            Acceso instantáneo después de tu compra. 100% privado y seguro.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex items-center justify-center gap-2 text-gray-400" data-id="element-99">
          <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-100" />
          <span className="text-sm" data-id="element-101">Pago seguro con encriptación SSL</span>
        </motion.div>
      </div>
    </section>;
}